// removed by extract-text-webpack-plugin
module.exports = {"launch-your-page-container":"_2DzWM","launch-your-page-header":"_2vI5b","launch-your-page-paragraph":"_12IEb","launch-your-page-text":"_4P2tp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Supporters/LaunchYourPage.scss
// module id = ./src/components/Supporters/LaunchYourPage.scss
// module chunks = 4